import { getErrorMessage, type SiteInfoManageField } from '@safetyhub/shared';

/**
 * 현장 정보 관리권(O10·Q8) 화면 판정 — 서버 응답 `canManageSiteInfo`(shared `SiteInfoManageField`)를 읽는 **유일한** 자리.
 *
 * 규칙(소유 조직 ∨ (현재 대행 링크 ∧ 소유 조직 활성 멤버 0))은 서버 `siteInfoManagedByWhere`가 정본이고 화면은 다시 계산하지 않는다.
 * 칸이 **없으면 막지 않는다**(`undefined` → false) — 현장 생성 응답·실시간 갱신 행처럼 그 칸을 싣지 않는 형상이 있고, 그때의
 * 판정은 서버 403 `SITE_INFO_MANAGED_BY_OWNER`가 한다. 이 함수는 미리 막는 재료일 뿐이다.
 *
 * 막힘은 **풀릴 수 있다**(업체가 활성 멤버를 모두 잃으면 다시 true) — 그래서 수정 진입은 감추지 않고 비활성 + 사유로 둔다
 * (같은 드롭다운의 「이관 대기」 비활성 선례와 같은 형태).
 *
 * ⚠️ `lib/organizations`(여러 spec이 `vi.mock`하는 모듈)에 두지 않은 것은 의도다 — 거기 새 export를 두면 그 모듈을 mock하는
 * 무관한 spec이 `No "isSiteInfoLocked" export is defined on the mock`으로 죽는다.
 */
export function isSiteInfoLocked(site: Partial<SiteInfoManageField> | null | undefined): boolean {
  return site?.canManageSiteInfo === false;
}

/** 막혔을 때 보이는 사유 — 서버 403 `SITE_INFO_MANAGED_BY_OWNER`의 문구와 한 벌(shared 메시지 정본). */
export function siteInfoLockedReason(): string {
  return getErrorMessage('SITE_INFO_MANAGED_BY_OWNER');
}
